import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Nav = () => {
    const { pathname } = useLocation();
    return (
        <StyledNav>
            <h1><Link to='/' id="logo">Capture</Link></h1>
            <ul>
                <li>
                    <Link to="/">1. About Us</Link>
                    <Line transition={{ duration: 0.75 }} initial={{ width: "0%" }} animate={{ width: pathname === '/' ? "50%" : '0%' }} />
                </li>
                <li>
                    <Link to="/work">2. Our work</Link>
                    <Line transition={{ duration: 0.75 }} initial={{ width: "0%" }} animate={{ width: pathname === '/work' ? "50%" : '0%' }} />
                </li>
                <li>
                    <Link to="/contact">3. Contact Us</Link>
                    <Line transition={{ duration: 0.75 }} initial={{ width: "0%" }} animate={{ width: pathname === '/contact' ? "50%" : '0%' }} />
                </li>
            </ul>
        </StyledNav>
    );
};

const StyledNav = styled.div`
    min-height: 10vh;
    display: flex;
    margin: auto;
    justify-content: space-between;
    align-items:center;
    padding: 1rem 10rem;
    background: #282828;
    position: sticky;
    top:0;
    z-index: 10;
    a{
        color: white;
        text-decoration:none;
    }

    ul{
        display: flex;
        list-style:none;
    }
    #logo{
        font-family: 'Lobster', cursive;
        font-size: 2rem;
        font-weight:lighter;
    }

    li{
        position:relative;
        padding-left: 10rem;
    }
    @media (max-width: 1300px) {
        flex-direction: column;
        padding: 2rem 1rem;
        #logo {
        display: inline-block;
        margin: 1rem;
        }
    ul {
      padding: 2rem;
      justify-content: space-around;
      width: 100%;
      li {
        padding: 0;
      }
    }
    }
`
const Line = styled(motion.div)`
    height: 0.3rem;
    background: #23d997;
    width: 0%;
    position: absolute;
    bottom: -80%;
    left: 60%;
`
export default Nav;